import React from "react";
import GameButtonWithIcon from "./GameButtonWithIcon";
import minus from "../../images/gameplay_ui/icons/minus.svg"
import add from "../../images/gameplay_ui/icons/plus.svg"
import UtilsFunctions from "../../utils/UtilsFunctions";
export default class AddRemoveButtons extends React.Component{

    minus(){
        this.props.onValueChanged((this.props.currentRuntime ?? this.props.value) - (this.props.step ?? 1));
    }
    add(){
        this.props.onValueChanged((this.props.currentRuntime ?? this.props.value) + (this.props.step ?? 1));
    }
    render() {
        let style = {
            display: "flex",
            justifyContent: "space-between",
            width: `${this.props.width ?? 80}px`,
            height: `${this.props.height ?? 20}px`
        }
        let value = "";

        if (this.props.asInputNumber) {
            value = <input disabled={this.props.disabled} className={"popup-input"} type={'number'} value={UtilsFunctions.toPrettyNumber(this.props.value)} onChange={(e) => {
                let val = parseInt(e.target.value);
                if (isNaN(val))
                    val = 0;

                let newValue = val <= this.props.max ? val : this.props.max;

                this.props.onValueChanged(newValue);
                e.target.value = newValue;
            }} />
        } else {
            if (this.props.currentRuntime === 0) {
                value = <div>{UtilsFunctions.toPrettyNumber(this.props.value)}</div>
            } else {
                value = <div>{UtilsFunctions.toPrettyNumber(this.props.value)}{this.props.currentRuntime > 0 ? "+" + this.props.currentRuntime : this.props.currentRuntime}</div>;
            }
        }

        let colors = this.props.colors ?? ["#56CCF2", "#2D9CDB"];
        return <div style={{...style, ...this.props.style}} className={this.props.className}>
            <GameButtonWithIcon
                colorStart={colors[0]}
                colorEnd={colors[1]}
                icon={minus}
                width={this.props.buttonsSize ?? 20}
                height={this.props.buttonsSize ?? 20}
                onClick={this.minus.bind(this)}
                disabled={!this.props.isCanSell}/>
            {this.props.isHideText ? "" : value}
            <GameButtonWithIcon
                colorStart={colors[0]}
                colorEnd={colors[1]}
                icon={add}
                width={this.props.buttonsSize ?? 20}
                height={this.props.buttonsSize ?? 20}
                onClick={this.add.bind(this)}
                disabled={!(this.props.isCanBuy)}
            />
        </div>
    }
}
